import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule, MasterDetailModule } from '@sdbn/common';
import { ServiceResponseModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { YardStructureComponent } from './component/yard-structure.component';
import { StationGroupDetailsComponent } from './component/stationgroup-details/stationgroup-details.component';
import { StationSetComponent } from './component/stationset/stationset-component';
import { ColorPickerModule } from '@sdbn/tmc-common';
import { BackupReferenceComponent } from './component/backup-reference/backup-reference.component';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatInputModule as MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    YardStructureComponent,
    StationGroupDetailsComponent,
    StationSetComponent,
    BackupReferenceComponent
  ],
  imports: [
    CommonModule,
    FormsModule,

    ReactiveFormsModule,
    ColorPickerModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonUIModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    DragDropModule,
    MatInputModule
  ]
})
export class YardStructureModule { }
